import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AnalyticsService } from "@modules/core";
import { generateUpgradeUrl } from "@utils";
import { NetworkUserPickerService } from "./../network-user-picker.service";

@Component({
  selector: "app-conversation-type-buttons",
  templateUrl: "./conversation-type-buttons.component.html",
  styleUrls: ["./conversation-type-buttons.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConversationTypeButtonsComponent {
  public isNewExternalChatEnabled$ =
    this.networkUserPickerService.isNewExternalChatEnabled$;

  public isConversationLimitNoticeVisible$ =
    this.networkUserPickerService.isConversationLimitNoticeVisible$;

  public upgradeUrl = generateUpgradeUrl();
  public groupConversationRemainingText$ =
    this.networkUserPickerService.groupConversationRemainingText$;

  public caseConversationRemainingText$ =
    this.networkUserPickerService.caseConversationRemainingText$;

  public externalConversationRemainingText$ =
    this.networkUserPickerService.externalConversationRemainingText$;

  public constructor(
    private networkUserPickerService: NetworkUserPickerService,
    private analyticsService: AnalyticsService
  ) {}

  public onLimitBannerVisible(): void {
    this.analyticsService
      .logEvent({
        eventType: "ConversationCreationLimitBanner",
        timestamp: new Date().toISOString(),
      })
      .subscribe();
  }

  public onLearnMoreClick(): void {
    this.networkUserPickerService.openConversationLimitsLearnMore();
  }

  public handleGroupClick() {
    this.networkUserPickerService.onCreateGroup();
  }

  public handleCaseClick() {
    this.networkUserPickerService.onCreateCase();
  }

  public handleExternalClick() {
    this.networkUserPickerService.onCreateExternal();
  }
}
